import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Prizes } from "@/components/Prizes";
import { Steps } from "@/components/Steps";
import { Bonus } from "@/components/Bonus";
import { NextDraw } from "@/components/NextDraw";
import { Trust } from "@/components/Trust";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { StickyCta } from "@/components/StickyCta";
import { Reveal } from "@/components/Reveal";
import { GiveawayForm } from "@/components/GiveawayForm";
import { Countdown } from "@/components/Countdown";
import { trackEvent } from "@/lib/api";

const readUtm = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      if (p.get(k)) sessionStorage.setItem(k, p.get(k));
    });
    const get = (k) => p.get(k) || sessionStorage.getItem(k) || undefined;
    return {
      utm_source: get("utm_source"), utm_medium: get("utm_medium"), utm_campaign: get("utm_campaign"),
      utm_content: get("utm_content"), utm_term: get("utm_term"),
    };
  } catch {
    return {};
  }
};

export default function LandingPage() {
  const lenisRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const [utm] = useState(readUtm);

  useEffect(() => {
    trackEvent("page_view");
    const lenis = new Lenis({ lerp: 0.1 });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -64 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToForm = () => scrollToId("teilnehmen");

  return (
    <main id="top" className="relative bg-paper" data-testid="landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Header onNavigate={scrollToId} />

      {/* Sektion 1: Hero + Formular */}
      <section id="teilnehmen" className="scroll-mt-20 bg-paper pb-14 pt-24 md:pb-20 md:pt-32" data-testid="hero-section">
        <div className="mx-auto grid w-full max-w-[1180px] grid-cols-1 items-start gap-10 px-5 lg:grid-cols-2 lg:gap-14">
          <div className="pt-1">
            <Hero />
            <div className="mt-8">
              <Countdown />
            </div>
          </div>
          <Reveal y={24}>
            <GiveawayForm utm={utm} onSuccess={() => setSubmitted(true)} />
          </Reveal>
        </div>
      </section>

      <Prizes />
      <Steps />
      <Bonus />
      <NextDraw />
      <Trust />
      <Faq />
      <FinalCta onScrollToForm={scrollToForm} />
      <Footer />
      <StickyCta onScrollToForm={scrollToForm} submitted={submitted} />
    </main>
  );
}
